var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3002_7263)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3002_7263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.959 61.7275V89.9987H115.224C113.5 99.0905 108.326 106.789 100.566 111.965L124.245 130.348C138.041 117.607 146 98.892 146 76.6602C146 71.4839 145.536 66.5061 144.673 61.7283L75.959 61.7275Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.071 88.895L29.7306 92.9853L10.8271 107.718C22.8323 131.542 47.4377 148.001 75.9581 148.001C95.6567 148.001 112.172 141.497 124.244 130.348L100.565 111.965C94.065 116.345 85.7741 119 75.9581 119C56.9887 119 40.8717 106.192 35.1009 88.9372L35.071 88.895Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.827 42.2832C5.85274 52.1047 3.00098 63.1876 3.00098 75.0002C3.00098 86.8128 5.85274 97.8958 10.827 107.717C10.827 107.783 35.103 88.8699 35.103 88.8699C33.6439 84.4899 32.7814 79.8447 32.7814 74.9995C32.7814 70.1542 33.6439 65.5091 35.103 61.1291L10.827 42.2832Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9596 31.0674C86.7047 31.0674 96.2556 34.7837 103.883 41.9511L124.776 21.0467C112.107 9.23413 95.659 2 75.9596 2C47.4392 2 22.8323 18.3919 10.8271 42.283L35.1025 61.1304C40.8726 43.8756 56.9902 31.0674 75.9596 31.0674Z",
    fill: "#EA4335"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3002_7263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3002_7263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 146,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.1df56911ff816ef1c9c99d2079309b6a.svg";
export { ForwardRef as ReactComponent };